import {init} from "../integration/init.js";
import "./data.ts";

// window.LEO.helloNoAuthHandler =
window.LEO.helloTimeoutHandler = () => init({
	integration:     "demo",
	container:       "#demo-sidebar",
	alwaysVisible:   true,
	projectSelector: false,
	accountMenu:     false
});
